import { render, staticRenderFns } from "./_helpCollection.vue?vue&type=template&id=6a3296d9&"
import script from "./_helpCollection.vue?vue&type=script&lang=js&"
export * from "./_helpCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports